import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's the insertBefore error - if so, don't show error screen
    if (error && error.message && error.message.includes('insertBefore')) {
      console.warn('Caught insertBefore error - suppressing:', error.message);
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error but don't crash for insertBefore errors
    if (error && error.message && error.message.includes('insertBefore')) {
      console.warn('ErrorBoundary caught insertBefore error:', error);
      // Reset error state to allow continued operation
      this.setState({ hasError: false, error: null });
      return;
    }
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <div className="text-center">
            <h2 className="text-xl font-bold text-slate-900 mb-2">Algo deu errado</h2>
            <p className="text-slate-500 mb-4">Ocorreu um erro inesperado.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
